









































































































































































import { Component, Vue, Prop, Inject, InjectReactive } from 'vue-property-decorator'
import { CurrentUser, ManageFeatures } from '@/_interfaces/CurrentUser'

@Component({})
export default class Menu extends Vue {
  @Prop()
  onMenuClick?: (e: MouseEvent) => void

  @Inject('logout')
  clickLogout!: () => void

  @Inject('is-observer')
  readOnly!: () => boolean

  @InjectReactive('user')
  user!: CurrentUser

  get manageFeatures(): ManageFeatures {
    return this.user.manage_features
  }

  get isShowOutdoor() {
    return !('outdoor_map' in this.manageFeatures) || this.manageFeatures.outdoor_map
  }

  get isShowIndoor() {
    return !('indoor_map' in this.manageFeatures) || this.manageFeatures.indoor_map
  }

  onClickHandler(e: MouseEvent) {
    // Execute this method if not undefined
    if (this.onMenuClick) {
      this.onMenuClick(e)
    }
  }
}
